import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react'
import SingleSelectDropdown from '../../Common Components/SingleSelectDropdown';
import { Switch, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import './Task Components.css';
import taskInfo from '../../../Assets/task-info.svg';
import ColorPicker from './Task Components Widgets/Color Picker';
import TaskServiceController from '../../../Controllers/TaskService';
import { MdAddCall, MdClear, MdOutlineAddCircle, MdOutlineClear } from 'react-icons/md';
import { DeleteForever } from '@mui/icons-material';

const TaskComponents = forwardRef((props, ref) => {
  // const TaskComponents = ({optionSet,onChange,selectedOption}) => {
  let { optionSet, onChange, selectedOption, taskParams, onEdit, ...rest } = props;
  const taskCont = new TaskServiceController();
  const [disableChecked, setDisableChecked] = useState(onEdit ? taskParams['disable'] : false);
  const [hideChecked, setHideChecked] = useState(onEdit ? taskParams['hide'] : false);
  const [numberOnlyChecked, setNumberOnlyChecked] = useState(onEdit ? taskParams['numberOnly'] : false);
  const [alphabetOnlyChecked, setAlphabetOnlyChecked] = useState(onEdit ? taskParams['alphabetOnly'] : false);
  const [taskParameters, setTaskParameters] = useState([]);
  const [colorParameterField, setColorParameterField] = useState([{ dropdownValue: null, inputValue: '', color: { color: '', displayColorPicker: false } }]);
  const [dropdownValuesOtherThanColor, setDropdownValuesOtherThanColor] = useState(Array(7).fill(null));
  const [inputFieldsOtherThanColor, setInputFieldsOtherThanColor] = useState(Array(7).fill(null));

  useEffect(() => {
    setDisableChecked(false);
    setHideChecked(false);
    setColorParameterField([{ dropdownValue: null, inputValue: '', color: { color: '', displayColorPicker: false } }]);
    setDropdownValuesOtherThanColor(Array(7).fill(null));
    setInputFieldsOtherThanColor(Array(7).fill(null));
  }, [optionSet])

  useEffect(() => {
    if (onEdit && taskParams && taskParams.length > 0 && (optionSet['value'] === 'BGColor' || optionSet['value'] === 'TextColor')) {
      const newFields = taskParams.map(param => ({
        // dropdownValue: {
        //   label: param.Operator.label || param.Operator,
        //   value: param.Operator.value || param.Operator
        // },
        dropdownValue: param['Operator'],
        inputValue: param.CheckValue,
        color: {
          color: param.Value,
          displayColorPicker: false
        }
      }));
      setColorParameterField(newFields);
    }
  }, [taskParams, onEdit, optionSet]);


  useEffect(() => {
    if (optionSet['value'] === 'DateFormat' || optionSet['value'] === 'BGColor' || optionSet['value'] === 'TextColor' || optionSet['value'] === 'TimeFormat') getParameters();
  }, [optionSet]);

  useEffect(() => {
    const editingTaskcategory = optionSet['value'];
    if (onEdit) {
      switch (editingTaskcategory) {
        case 'DateFormat':
          setPredefinedValuesOnEdit_forDropdown(optionSet);
          break;
        case 'BGColor':
        case 'TextColor':
          setPredefinedValuesOnEdit_forInputFields(optionSet);
          setPredefinedValuesOnEdit_forDropdown(optionSet);
          break;
        case 'MaxLength':
          setPredefinedValuesOnEdit_forInputFields(optionSet);
          break;
        default:
          console.log('no task catgory to preload values');
      }
    }

  }, [optionSet, onEdit]);

  const getParameters = async () => {
    if (optionSet['value'] !== '--select--' && optionSet['value'] !== undefined) {
      const body = await taskCont.getTaskParametersList(optionSet['id']);
      setTaskParameters(
        Array.isArray(body[0]['taskParameter']) && body.length > 0
          ? body[0]['taskParameter'].map((item, index) => ({
            label: item.label,
            value: item.value,
          }))
          : []
      );
    }
    else {
      setTaskParameters([]);
    }
  }

  const setPredefinedValuesOnEdit_forInputFields = (editTskctgy) => {
    if (editTskctgy['value'] !== '--select--' && editTskctgy['value'] !== undefined && onEdit) {
      const editTaskCategory = editTskctgy['value'];
      switch (editTaskCategory) {
        case 'MaxLength':
          updateFieldValuesOtherThanColor(1, taskParams['txtLength']);
          break;
        case 'TextColor':
        case 'BGColor':
          taskParams.forEach((param, index) => {
            updateFieldValue(index, param['CheckValue']);
          });
          break;
        default:
          console.log('No task category  to edit');
          break;
      }
    }
  }

  const setPredefinedValuesOnEdit_forDropdown = (editTskctgy) => {
    if (editTskctgy['value'] !== '--select--' && editTskctgy['value'] !== undefined && onEdit) {
      const editTaskCategory = editTskctgy['value'];
      switch (editTaskCategory) {
        case 'DateFormat':
          updateDropdownValuesOtherThanColor(1, taskParams['dateFormat']);
          break;
        case 'TextColor':
        case 'BGColor':
          taskParams.forEach((param, index) => {
            updateDropdownValue(index, param['Operator']);
          });
          break;
        default:
          console.log('No task category  to edit');
          break;
      }
    }
  }

  const handleChange = (fieldName) => {
    switch (fieldName) {
      case 'disable':
        setDisableChecked(!disableChecked);
        break;
      case 'hide':
        setHideChecked(!hideChecked);
        break;
      case 'numberOnly':
        setNumberOnlyChecked(!numberOnlyChecked);
        break;
      case 'alphabetOnly':
        setAlphabetOnlyChecked(!alphabetOnlyChecked);
        break;
      default:
        console.log('no hide function');
    }
  }


  const updateDropdownValuesOtherThanColor = (index, value) => {
    setDropdownValuesOtherThanColor(prevFields => {
      const newFields = [...prevFields];
      newFields[index] = value;
      return newFields;
    });
  };

  const updateFieldValuesOtherThanColor = (index, value) => {
    setInputFieldsOtherThanColor(prevFields => {
      const newFields = [...prevFields];
      newFields[index] = value;
      return newFields;
    });
  };

  const handleDropdownChangesOtherThanColor = (index, selectedValue, option, field) => {
    const newFields = [...dropdownValuesOtherThanColor];
    newFields[index] = option;
    setDropdownValuesOtherThanColor(newFields);
  };

  const handleInputFieldChangesOtherThanColor = (index, event) => {
    const newFields = [...inputFieldsOtherThanColor];
    newFields[index] = event.target.value;
    setInputFieldsOtherThanColor(newFields);
  };

  const addField = () => {
    setColorParameterField([...colorParameterField, { dropdownValue: null, inputValue: '', color: { color: '', displayColorPicker: false } }]);
  };

  const removeField = (index) => {
    const newFields = colorParameterField.filter((_, i) => i !== index);
    setColorParameterField(newFields);
  };

  const handleColorClicks = (index) => {
    const newFields = [...colorParameterField];
    newFields[index].color.displayColorPicker = !newFields[index].color.displayColorPicker;
    setColorParameterField(newFields);
  };

  const handleColorChanges = (index, color) => {
    const newFields = [...colorParameterField];
    newFields[index].color.color = color.hex;
    setColorParameterField(newFields);
  };

  const handleDropdownChange = (index, option) => {
    // const newFields = [...colorParameterField];
    // newFields[index].dropdownValue = option;
    // setColorParameterField(newFields);
    setColorParameterField(prevFields =>
      prevFields.map((field, i) =>
        i === index
          ? { ...field, dropdownValue: option }
          : field
      )
    );
  };

  const handleInputFieldChanges = (index, event) => {
    const newFields = [...colorParameterField];
    newFields[index].inputValue = event.target.value;
    setColorParameterField(newFields);
  };

  const updateDropdownValue = (index, option) => {
    setColorParameterField(prevFields => {
      const newFields = [...prevFields];
      if (newFields[index]) {
        newFields[index].dropdownValue = option;
      }
      else {
        console.error(`Index ${index} is out of bounds`);
      }
      return newFields;
    });
  };

  const updateFieldValue = (index, value) => {
    setColorParameterField(prevFields => {
      const newFields = [...prevFields];
      if (newFields[index]) {
        newFields[index].inputValue = value;
      } else {
        console.error(`Index ${index} is out of bounds`);
      }
      return newFields;
    });
  };

  const checkEmptyValuesMaxLength = () => {
    const check = (inputFieldsOtherThanColor[1] === null || inputFieldsOtherThanColor[1] === '') ? true : false;
    return check;
  }

  const checkEmptyValuesDate = () => {
    const check = (dropdownValuesOtherThanColor[1] === null) ? true : false;
    return check;
  }

  function validateFields() {
    let hasIncompleteRow = false;
    let filledCount = 0;
    const totalFields = colorParameterField.length * 3; // Total number of fields to check

    colorParameterField.forEach((field) => {
      const { inputValue, dropdownValue, color } = field;

      if (inputValue !== '') filledCount += 1;
      if (dropdownValue !== null) filledCount += 1;
      if (color.color !== '') filledCount += 1;
    });

    if (filledCount === 0 || filledCount < totalFields) {
      hasIncompleteRow = true;
    }
    return hasIncompleteRow;
  }

  useImperativeHandle(ref, () => ({
    saveValidations, createJson
  }));

  function saveValidations(taskCategory) {
    let empty = false;

    if (taskCategory === "BGColor" || taskCategory === "TextColor") {
      empty = validateFields();
      if (empty) {
        alert('Please fill empty fields before saving or remove empty rows');
        return null;
      }
    } else if (taskCategory === "MaxLength") {
      empty = checkEmptyValuesMaxLength();
      if (empty) {
        alert('Please specify task parameter before saving');
        return null;
      }
    }
    else if (taskCategory === "DateFormat") {
      empty = checkEmptyValuesDate();
      if (empty) {
        alert('Please specify task parameter before saving');
        return null;
      }
    }
    //empty = true;
    // If no alerts are triggered, createJson will be called
    if (!empty) {
      return true;
    }
    else {
      return null;
    }
  }
  const createJson = (taskCategory) => {
    const taskParameter =
      taskCategory === "BGColor"
        ?
        colorParameterField.map((field) => ({
          Operator: field.dropdownValue,
          CheckValue: field.inputValue,
          Value: field.color.color,
        }))
        : taskCategory === "TextColor"
          ?
          colorParameterField.map((field) => ({
            Operator: field.dropdownValue,
            CheckValue: field.inputValue,
            Value: field.color.color,
          }))
          : taskCategory === "Hide"
            ? {
              hide: hideChecked,
            }
            : taskCategory === "Disable"
              ? {
                disable: disableChecked,
              }
              : taskCategory === 'NumberOnly'
                ? {
                  numberOnly: numberOnlyChecked,
                }
                : taskCategory == 'AlphabetOnly'
                  ? {
                    alphabetOnly: alphabetOnlyChecked,
                  }
                  : taskCategory === "MaxLength"
                    ? {
                      txtLength: inputFieldsOtherThanColor[1],
                    }
                    : {
                      dateFormat: dropdownValuesOtherThanColor[1],
                    };

    const jsonString = JSON.stringify(taskParameter, null, 2);
    return jsonString;
  }


  const ToggleSwitch = styled(Switch)(({ theme }) => ({
    padding: 10,
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        transform: 'translateX(20px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#02acf6',
          ...theme.applyStyles('dark', {
            backgroundColor: '#177ddc',
          }),
        },
      },
    },
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      backgroundColor: '#fff',
      width: 13.5,
      height: 13.5,
      margin: 2.5,
    },
  }));

  return (
    <>
      <div style={{ padding: "10px", }}>
        {optionSet["value"] === "DateFormat" && (
          <div className='date-format'>
            <p>Date Format</p>
            <SingleSelectDropdown
              options={taskParameters}
              onChange={(value) =>
                handleDropdownChangesOtherThanColor(1, value["value"], value, optionSet["value"])}
              valueSet={dropdownValuesOtherThanColor[1]}
              taskCtg={false}
              placeHolder={dropdownValuesOtherThanColor[1]?.label || "Select date format..."}
            />
            <Tooltip title={selectedOption.description ?? "No description available"}>
              <img
                src={taskInfo}
                style={{ transform: "translateX(800px)", cursor: 'pointer' }}
                onClick={() => createJson(optionSet["value"])}
              />
            </Tooltip>
          </div>
        )}
        {optionSet["value"] === "MaxLength" && (
          <div className='max-length'>
            <p>Parameter</p>
            <input
              style={{ height: "30px", width: "85px", padding: '0px 5px', border: "1px solid #cfd4e9", borderRadius: "3px", fontSize: "17px", fontWeight: "500", textAlign: "center", }}
              onChange={(event) => {
                handleInputFieldChangesOtherThanColor(1, event);
              }}
              type='number'
              value={inputFieldsOtherThanColor[1] || ""}
              onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
            />
            <Tooltip title={selectedOption.description ?? "No description available"}>
              <img
                src={taskInfo}
                style={{ transform: "translateX(1000px)", cursor: 'pointer' }}
                onClick={() => createJson(optionSet["value"])}
              />
            </Tooltip>
          </div>
        )}
        {optionSet["value"] === "BGColor" && (
          <div className="color-grids">
            <div className="grid-column-names" style={{ marginLeft: "16%", justifyContent: "space-between" }}>
              <p >Value Type</p>
              <p>Value</p>
              <p style={{ width: "33%", }}>Color</p>
              <Tooltip title={selectedOption.description ?? "No description available"}>
                <img
                  src={taskInfo}
                  style={{
                    position: "absolute",
                    right: "20%",
                    cursor: "pointer",
                  }}
                  onClick={() => createJson(optionSet["value"])}
                />
              </Tooltip>
            </div>

            <div style={{ width: "100%" }}>
              {colorParameterField.map((field, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    gap: "30px",
                    alignItems: "center",
                    width: "100%",
                    margin: "5px 50px",
                  }}
                >
                  <SingleSelectDropdown
                    className="dropdown"
                    options={taskParameters}
                    taskCtg={false}
                    valueSet={field.dropdownValue}
                    onChange={(value) => handleDropdownChange(index, value)}
                    placeHolder={field.dropdownValue?.label || "Select value type..."}
                  />
                  <input
                    className="value"
                    type="number"
                    onChange={(event) => handleInputFieldChanges(index, event)}
                    value={field.inputValue || ""}
                  />
                  <ColorPicker
                    color={field.color.color}
                    displayColorPicker={field.color.displayColorPicker}
                    onColorChange={(color) => handleColorChanges(index, color)}
                    onColorClick={() => handleColorClicks(index)}
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: "fit-content",
                      gap: "10px",
                      padding: " 0px 10px",
                    }}
                  >
                    <MdOutlineAddCircle
                      style={{ fontSize: "25px", cursor: "pointer", color: '#38e715' }}
                      onClick={addField}
                    />
                    <DeleteForever
                      style={{ fontSize: "25px", cursor: "pointer", color: colorParameterField.length === 1 ? '#757ea5' : '#f32f0d ', fontWeight: 'bold' }}
                      onClick={colorParameterField.length === 1 ? null : () => removeField(index)}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {optionSet["value"] === "TextColor" && (
          <div className="color-grids">
            <div className="grid-column-names" style={{ marginLeft: "16%", justifyContent: "space-between" }}>
              <p>Value Type</p>
              <p>Value</p>
              <p style={{ width: "33%", }}>Color</p>
              <Tooltip title={selectedOption.description ?? "No description available"}>
                <img
                  src={taskInfo}
                  style={{
                    position: "absolute",
                    right: "20%",
                    cursor: "pointer",
                  }}
                  onClick={() => createJson(optionSet["value"])}
                />
              </Tooltip>
            </div>

            <div style={{ width: "100%" }}>
              {colorParameterField.map((field, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    gap: "30px",
                    alignItems: "center",
                    width: "100%",
                    margin: "5px 50px",
                  }}
                >
                  <SingleSelectDropdown
                    className="dropdown"
                    options={taskParameters}
                    taskCtg={false}
                    valueSet={field.dropdownValue}
                    onChange={(value) => handleDropdownChange(index, value)}
                    placeHolder={field.dropdownValue?.label || "Select value type..."}
                  />
                  <input
                    className="value"
                    type="number"
                    onChange={(event) => handleInputFieldChanges(index, event)}
                    value={field.inputValue || ""}
                  />
                  <ColorPicker
                    color={field.color.color}
                    displayColorPicker={field.color.displayColorPicker}
                    onColorChange={(color) => handleColorChanges(index, color)}
                    onColorClick={() => handleColorClicks(index)}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: "fit-content",
                      gap: "10px",
                      padding: " 0px 10px",
                    }}
                  >
                    <MdOutlineAddCircle
                      style={{ fontSize: "25px", cursor: "pointer", color: '#38e715' }}
                      onClick={addField}
                    />
                    <DeleteForever
                      style={{ fontSize: "25px", cursor: "pointer", color: colorParameterField.length === 1 ? '#757ea5' : '#f32f0d ', fontWeight: 'bold' }}
                      onClick={colorParameterField.length === 1 ? null : () => removeField(index)}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {optionSet["value"] === "Hide" && (
          <div className='hide' >
            <p style={{ color: "#757EA5", fontSize: "17px", fontWeight: "500", }}>Hide
              <ToggleSwitch
                checked={hideChecked}
                onChange={() => {
                  handleChange("hide");
                }}
                inputProps={{ "aria-label": "controlled" }}
              /></p>
            <Tooltip title={selectedOption.description ?? "No description available"}>
              <img
                src={taskInfo}
                style={{ transform: "translateX(1000px)", cursor: 'pointer' }}
                onClick={() => createJson(optionSet["value"])}
              />
            </Tooltip>
          </div>
        )}
        {optionSet["value"] === "Disable" && (
          <div className='disable' >
            <p style={{ color: "#757EA5", fontSize: "17px", fontWeight: "500", }}>Disable
              <ToggleSwitch
                checked={disableChecked}
                onChange={() => {
                  handleChange("disable");
                }}
                inputProps={{ "aria-label": "controlled" }}
              /></p>
            <Tooltip title={selectedOption.description ?? "No description available"}>
              <img
                src={taskInfo}
                style={{ transform: "translateX(1000px)", cursor: 'pointer' }}
                onClick={() => createJson(optionSet["value"])}
              />
            </Tooltip>
          </div>
        )}
        {optionSet["value"] === "TimeFormat" && (
          <div className='date-format'>
            <p>Time Formate</p>
            <SingleSelectDropdown
              options={taskParameters}
              onChange={(value) =>
                handleDropdownChangesOtherThanColor(1, value["value"], value, optionSet["value"])}
              valueSet={dropdownValuesOtherThanColor[1]}
              taskCtg={false}
              placeHolder={dropdownValuesOtherThanColor[1]?.label || "Select time format..."}
            />
            <Tooltip title={selectedOption.description ?? "No description available"}>
              <img
                src={taskInfo}
                style={{ transform: "translateX(800px)", cursor: 'pointer' }}
                onClick={() => createJson(optionSet["value"])}
              />
            </Tooltip>
          </div>
        )}
        {optionSet["value"] === "NumberOnly" && (
          <div className='numberOnly' >
            <p style={{ color: "#757EA5", fontSize: "17px", fontWeight: "500", }}>Number Only
              <ToggleSwitch
                checked={numberOnlyChecked}
                onChange={() => {
                  handleChange("numberOnly");
                }}
                inputProps={{ "aria-label": "controlled" }}
              /></p>
            <Tooltip title={selectedOption.description ?? "No description available"}>
              <img
                src={taskInfo}
                style={{ transform: "translateX(1000px)", cursor: 'pointer' }}
                onClick={() => createJson(optionSet["value"])}
              />
            </Tooltip>
          </div>
        )}
        {optionSet["value"] === "AlphabetOnly" && (
          <div className='alphabetOnly' >
            <p style={{ color: "#757EA5", fontSize: "17px", fontWeight: "500", }}>Alphabet Only
              <ToggleSwitch
                checked={alphabetOnlyChecked}
                onChange={() => {
                  handleChange("alphabetOnly");
                }}
                inputProps={{ "aria-label": "controlled" }}
              /></p>
            <Tooltip title={selectedOption.description ?? "No description available"}>
              <img
                src={taskInfo}
                style={{ transform: "translateX(1000px)", cursor: 'pointer' }}
                onClick={() => createJson(optionSet["value"])}
              />
            </Tooltip>
          </div>
        )}
        {optionSet["value"] === "RemoveLeading" && (
          <div className='removeLeading'>
            <p>Remove Leading</p>
            <input
              style={{ height: "30px", width: "85px", padding: '0px 5px', border: "1px solid #cfd4e9", borderRadius: "3px", fontSize: "17px", fontWeight: "500", textAlign: "center", }}
              onChange={(event) => {
                handleInputFieldChangesOtherThanColor(1, event);
              }}
              // type='number'
              value={inputFieldsOtherThanColor[1] || ""}
              onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
            />
            <Tooltip title={selectedOption.description ?? "No description available"}>
              <img
                src={taskInfo}
                style={{ transform: "translateX(1000px)", cursor: 'pointer' }}
                onClick={() => createJson(optionSet["value"])}
              />
            </Tooltip>
          </div>
        )}
        {optionSet["value"] === "RemoveTrailing" && (
          <div className='removeTrailing'>
            <p>Remove Trailling </p>
            <input
              style={{ height: "30px", width: "85px", padding: '0px 5px', border: "1px solid #cfd4e9", borderRadius: "3px", fontSize: "17px", fontWeight: "500", textAlign: "center", }}
              onChange={(event) => {
                handleInputFieldChangesOtherThanColor(1, event);
              }}
              // type='number'
              value={inputFieldsOtherThanColor[1] || ""}
              onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
            />
            <Tooltip title={selectedOption.description ?? "No description available"}>
              <img
                src={taskInfo}
                style={{ transform: "translateX(1000px)", cursor: 'pointer' }}
                onClick={() => createJson(optionSet["value"])}
              />
            </Tooltip>
          </div>
        )}
      </div>
    </>
  );
});

export default TaskComponents;